import { render, staticRenderFns } from "./BudgetStats.vue?vue&type=template&id=0ce2a9da&"
import script from "./BudgetStats.vue?vue&type=script&lang=js&"
export * from "./BudgetStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports